const IsGenerallyVisible = (element: Element) => {
  if (window) {
    const style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
  }
  return false;
};
export default IsGenerallyVisible;